module.exports = __webpack_public_path__ + "b8359ac6bba55d5b7197cb5e35292390.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/head/goldencity3.jpg
// module id = 901
// module chunks = 0